export const isKzUrl = (host = '') => {
	if (!host) return false;

	if (
		host.includes('lmkz.tech') ||
		host.includes('lemanapro.kz') ||
		host.includes('kazakhstan.') ||
		host.includes('leroymerlin.kz')
	) {
		return true;
	} else {
		return false;
	}
};
